var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createContext, useContext, useEffect, useState, } from 'react';
import { createUninitializedApiClient } from '../apiClientUtils';
import { useLegoland } from '../LegolandContext';
import { createLegolandApiClient, } from './legolandApiClient';
var uninitializedClient = createUninitializedApiClient('Legoland');
var LegolandApiClientContext = createContext(uninitializedClient);
export var LegolandApiClientConsumer = LegolandApiClientContext.Consumer;
export function useLegolandApiClient() {
    return useContext(LegolandApiClientContext);
}
export var LegolandApiClientProvider = function (_a) {
    var children = _a.children;
    var legolandApiUrl = useLegoland().legolandApiUrl;
    var _b = __read(useState(), 2), client = _b[0], setClient = _b[1];
    useEffect(function onMountEffect() {
        setClient(createLegolandApiClient({ baseUrl: legolandApiUrl }));
    }, []);
    if (!client)
        return null;
    return (React.createElement(LegolandApiClientContext.Provider, { value: client }, children));
};
//# sourceMappingURL=LegolandApiClientContext.js.map